import { useEffect, useState } from "react";
import { useAppContext } from "../../libs/app-core/AppContext";
import { OnApiError } from "../ErrorManager";
import { UniOption } from "./UniOption";
import { DAO } from "./DAO";
import { API, ApiResult } from "./API";
import { WS } from "./WS";

export class UniOptionDAO {

  static async Insert(uni_question_guid: string, option_code: string, option_title: string): Promise<UniOption> {
    let data = new UniOption();

    data.question_guid = uni_question_guid;
    data.option_code = option_code;
    data.option_title = option_title;

    let refetch_data = await DAO.Insert(UniOption, data);
    return refetch_data;
  }

  static async Insert_新增空白選項(uni_question_guid: string): Promise<UniOption> {
    let data = new UniOption();

    data.question_guid = uni_question_guid;

    let refetch_data = await DAO.Insert(UniOption, data);
    return refetch_data;
  }

  static async Insert_拆分的子選項(split_from_option: UniOption) {
    let new_option = await UniOptionDAO.Insert_新增空白選項(split_from_option.question_guid);

    new_option.split_from_option_guid = split_from_option.guid;
    new_option.v3_group = split_from_option.v3_group;
    new_option.sort_no = split_from_option.sort_no;

    let re = await DAO.Update(UniOption, new_option);

    split_from_option.is_split_parent = 1;// 標記有拆分的子項目了
    await DAO.Update(UniOption, split_from_option);

    return re;
  }


  /** 修改指定欄位，DGV修改數值用 */
  static async UpdateOneField(data: UniOption, field: string, value: any) {

    if (field === "option_code" || field === "o_his_code") {
      value = (value as string).trim();// code 系列 自動先 trim(); 
    }

    (data as any)[field] = value;

    let re = await DAO.UpdateOnly(UniOption, data, [field]);

    return re;
  }

  static async Update_SetSortNo(data: UniOption, sort_no: number): Promise<UniOption> {
    data.sort_no = sort_no;
    let re = await DAO.UpdateOnly(UniOption, data, ["sort_no"]);
    return re;
  }

  static async Delete(data: UniOption): Promise<number> {
    let effect_rows_cnt = DAO.DeleteByGuid(UniOption, data.guid);
    return effect_rows_cnt;
  }

  static async FetchByGuid(guid: string): Promise<UniOption> {
    let data = await DAO.FetchByGuid(UniOption, guid);
    return data;
  }

  static async Select(question_guid: string | null): Promise<UniOption[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定所屬主檔(question_guid)
      + Cnd.OrderBy預設排序();

    let data_list = await DAO.Select(UniOption, cond);
    return data_list;
  }

  static async Select某個版本問卷的選項(form_guid: string | null): Promise<UniOption[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定特做版本(form_guid)
    let data_list = await DAO.Select(UniOption, cond);
    return data_list;
  }


  static async WS_SelectOptions_ByFormGuidList(form_guid_list: string[] | null | undefined): Promise<UniOption[]> {
    let api_rslt: ApiResult = await WS.CallWS(
      "uni_option/select_by_form_guid_list",
      { form_guid_list: form_guid_list }
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(UniOption, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

}

class Cnd {
  static 指定所屬主檔(question_guid: string | null) {
    return ` (question_guid='${question_guid}') `;
  }


  static OrderBy預設排序() {
    return ` ORDER BY sort_no, serno `;
  }

  static 指定特做版本(form_guid: string | null) {
    return ` (form_guid='${form_guid}') `;
  }

  static 指定所屬特作(form_guid_list: string[] | null | undefined) {
    if (form_guid_list == null) {
      return " (1=0) ";
    } else {
      let ary: any[] = [];
      form_guid_list?.forEach((guid: string) => {
        ary.push(`form_guid='${guid}'`)
      })
      return ary.join(' OR ');
    }
  }
}


export function useUniOption(guid: string) {
  const ctx = useAppContext();

  const [_UniOption, set_UniOption] = useState<UniOption | null>(null);

  async function refresh_UniOption() {
    try {
      const data_list = await UniOptionDAO.FetchByGuid(guid);
      set_UniOption(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniOption();
  }, [guid]);

  return { _UniOption, set_UniOption, refresh_UniOption }
}


export function useUniOptionList(question_guid: string | null) {
  const ctx = useAppContext();

  const [_UniOptionList, set_UniOptionList] = useState<UniOption[]>([]);

  async function refresh_UniOptionList() {
    try {
      const data_list = await UniOptionDAO.Select(question_guid);
      set_UniOptionList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniOptionList();
  }, [question_guid]);

  return { _UniOptionList, set_UniOptionList, refresh_UniOptionList }
}